(function () {
  'use strict';

  if (window.__arcaverseProductOptionRulesV1) return;
  window.__arcaverseProductOptionRulesV1 = true;

  /*
    ArcaVerse Ultra-Slim option rule:
    D20 / 26mm should only be selectable for larger/thicker deck sizes.
  */

  var THICK_DECK_SIZE_VALUES = [
    'MTG: Commander (100)',
    'MTG: Commander (120)',
    'Standard TCG / 100 Cards',
    'Standard TCG / 120 Cards'
  ];

  var DICE_OPTION_NAME = 'Dice Compartment';
  var DECK_SIZE_OPTION_NAME = 'Deck Size/Card Game';
  var D20_VALUE = 'D20 / 26mm';
  var FALLBACK_DICE_VALUE = 'None';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/compatible/g, '')
      .replace(/[^a-z0-9]+/g, '')
      .trim();
  }

  function getRoots() {
    return Array.prototype.slice.call(
      document.querySelectorAll('[id^="av-product-hero-"]')
    );
  }

  function getOptionSelect(root, optionName) {
    var wanted = normalize(optionName);
    var selects = Array.prototype.slice.call(
      root.querySelectorAll('.av-product-option-select')
    );

    for (var i = 0; i < selects.length; i++) {
      var name = selects[i].getAttribute('data-option-name') || '';
      if (normalize(name) === wanted) {
        return selects[i];
      }
    }

    return null;
  }

  function isThickDeckSize(value) {
    var selected = normalize(value);

    return THICK_DECK_SIZE_VALUES.some(function (allowedValue) {
      return normalize(allowedValue) === selected;
    });
  }

  function findOptionByValue(select, value) {
    if (!select) return null;

    var wanted = normalize(value);
    var options = Array.prototype.slice.call(select.options || []);

    for (var i = 0; i < options.length; i++) {
      if (normalize(options[i].value) === wanted) {
        return options[i];
      }
    }

    return null;
  }

  function getFirstVisibleEnabledOption(select) {
    if (!select) return null;

    var options = Array.prototype.slice.call(select.options || []);

    return options.find(function (option) {
      return !option.disabled && !option.hidden;
    }) || null;
  }

  function dispatchChange(select) {
    if (!select) return;

    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function setOptionAllowed(option, allowed) {
    if (!option) return;

    option.disabled = !allowed;
    option.hidden = !allowed;
    option.style.display = allowed ? '' : 'none';
    option.setAttribute('aria-disabled', allowed ? 'false' : 'true');
  }

  function enforceUltraSlimDiceRule(root) {
    if (!root) return;

    /*
      Limit this rule to Ultra-Slim pages.
      This avoids accidentally affecting Standard / Commander / future products.
    */
    var titleEl = root.querySelector('.av-product-hero__title');
    var title = titleEl ? titleEl.textContent : '';
    var path = window.location.pathname;

    var looksLikeUltraSlim =
      normalize(title).indexOf('ultraslim') !== -1 ||
      normalize(path).indexOf('ultraslim') !== -1;

    if (!looksLikeUltraSlim) return;

    var deckSelect = getOptionSelect(root, DECK_SIZE_OPTION_NAME);
    var diceSelect = getOptionSelect(root, DICE_OPTION_NAME);

    if (!deckSelect || !diceSelect) return;

    var allowD20 = isThickDeckSize(deckSelect.value);
    var d20Option = findOptionByValue(diceSelect, D20_VALUE);

    setOptionAllowed(d20Option, allowD20);

    /*
      If customer selected D20, then switches back to a smaller deck size,
      automatically move Dice Compartment back to None.
    */
    if (!allowD20 && normalize(diceSelect.value) === normalize(D20_VALUE)) {
      var fallbackOption =
        findOptionByValue(diceSelect, FALLBACK_DICE_VALUE) ||
        getFirstVisibleEnabledOption(diceSelect);

      if (fallbackOption) {
        diceSelect.value = fallbackOption.value;
        dispatchChange(diceSelect);
      }
    }
  }

  function setupRoot(root) {
    var deckSelect = getOptionSelect(root, DECK_SIZE_OPTION_NAME);
    var diceSelect = getOptionSelect(root, DICE_OPTION_NAME);

    if (!deckSelect || !diceSelect) return;

    function runSoon() {
      window.setTimeout(function () {
        enforceUltraSlimDiceRule(root);
      }, 0);

      window.setTimeout(function () {
        enforceUltraSlimDiceRule(root);
      }, 80);
    }

    deckSelect.addEventListener('change', runSoon);
    diceSelect.addEventListener('change', runSoon);

    runSoon();
    window.setTimeout(runSoon, 250);
    window.setTimeout(runSoon, 750);
  }

  ready(function () {
    getRoots().forEach(setupRoot);
  });

  window.addEventListener('pageshow', function () {
    getRoots().forEach(function (root) {
      enforceUltraSlimDiceRule(root);
    });
  });
})();